<fin-ancillary-header [title]="'ancillaries.seats.title' | finLocalization">
  <div class="teaser-wrapper font-body-1 flex flex--space-between mr-medium-t flex--middle">
    <span>{{ 'ancillaries.seats.usDotMessage' | finLocalization }}</span>
    <fcom-button
      data-testid="seatmap-sellection-skip-button"
      class="mr-medium-l"
      [text]="'ancillaries.seats.skipSeatSelection' | finLocalization"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      (clickBtn)="skipSeatSelection('top')"
    ></fcom-button>
  </div>

  <fin-ancillary-flight-bound-selector
    class="pr-small-t mobile-bleed"
    [showFlightCard$]="showFlightCard$"
    [boundsOrFlights]="flights$ | async"
    [activeBoundIndex]="slideIndex$ | async"
    [passengers]="passengers$ | async"
    (selectIndex)="slideIndex$.next($event)"
    (viewDetails)="viewDetails()"
    [locations]="locations"
    [focusOnDetails$]="itineraryModalClosed$"
  >
  </fin-ancillary-flight-bound-selector>
</fin-ancillary-header>

<div class="overflow-hidden mobile-bleed">
  <div class="slider nowrap fill slide-{{ slideIndex$ | async }}">
    <div
      *ngFor="let flight of flights$ | async; let i = index; trackBy: flightsTrackBy"
      class="inline-block valign-top fill"
    >
      <fin-seat-map-view
        [flight]="flight"
        [passengers$]="travelers$"
        [flightIsActive$]="i === (slideIndex$ | async) | finToObservable"
        [seatSelections$]="seatSelections$"
        [cartOrOrder$]="cartOrOrder$"
        [availability$]="flightAncillaryAvailability$"
        [ancillaryLoader$]="ancillaryLoader$"
        [seatWifiBundlesActivated$]="seatWifiBundlesActivated$"
        (retrySeatmap)="flightSelected.emit(flight)"
        (changeSeats)="changeSeats($event)"
        (toggleSeatWifiBundle)="emitToggleSeatWifiBundle(flight.id, $event)"
      >
      </fin-seat-map-view>
    </div>
  </div>
</div>

<fin-ancillary-sidebar
  [category$]="Category.SEAT | finToObservable"
  [isSideBarOpen]="isSideBarOpen"
  [boundsOrFlights$]="flights$"
  [locations]="locations"
  [passengers]="(cartOrOrder$ | async).passengers"
  (ctaSideBarClosed)="confirmSelection()"
  (sideBarClosed)="this.isSideBarOpen = false"
  (changeSelectedIndex)="slideIndex$.next($event)"
  [availability$]="flightAncillaryAvailability$"
  [subTotalPrice$]="totalPrice$"
  [passengersWithPetcIncompatibleSeats$]="passengersWithPetcIncompatibleSeats$"
  [ctaButtonText]="'actions.next'"
>
</fin-ancillary-sidebar>

<ng-container *ngIf="translationKey$ | async as translationKey">
  <fcom-cta-button
    data-testid="common-booking-ancillaries-seat-map-pre-selection-cta-button"
    [visible]="true"
    [title]="translationKey.key | finLocalization"
    [position]="ButtonPosition.GRID"
    [loading]="(seatMapPreloadingEnabled$ | async) ? (selectionLoading$ | async) : false"
    [theme]="
      (hasSelections$ | async) === true ? ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER : ButtonTheme.DARK_PRIMARY_NORDIC_BLUE
    "
    (buttonClicked)="continue()"
  >
    <span class="gray-50-text">{{ 'price.continueButtonTotal' | finLocalization }}: </span>
    <span class="font-body-1 bold-type">{{ totalPrice$ | async | finPrice | finEmpty: '&ndash;' }}</span>
  </fcom-cta-button>
</ng-container>

<fcom-modal
  class="itinerary-modal"
  [title]="'itinerary.title' | finLocalization"
  [buttons]="ModalButtons.DONE"
  (close)="itineraryModalClosed$.emit(true)"
  [(open)]="itineraryModal.open"
>
  <fin-itinerary
    *ngIf="itineraryModal.data && (itineraryModal.data.outbound$ || itineraryModal.data.inbound$)"
    class="block pr-medium"
    [selectionPhase$]="itineraryModal.data.selectionPhase$"
    [outbound$]="itineraryModal.data.outbound$"
    [inbound$]="itineraryModal.data.inbound$"
    [locations$]="itineraryModal.data.locations$"
  >
  </fin-itinerary>
</fcom-modal>
